module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page-index"
  }, [_c('page_head', {
    staticClass: "page-top"
  }), _vm._v(" "), (_vm.path === '/') ? [_c('div', {
    staticClass: "top-img"
  }, [_c('div', {
    staticClass: "top-img-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "top-img-content-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.gowork
    }
  }, [_vm._v("\n        Have Fun\n      ")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "index-content-3"
  }, [_c('div', {
    staticClass: "content-3-title"
  }, [_vm._v("\n      Mii-RO行业应用\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-3-text"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c3-6.png")
    },
    on: {
      "click": _vm.goSingle
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "index-content-line"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)] : _vm._e(), _vm._v(" "), _c('router-view')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c1.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-img-content-text"
  }, [_vm._v("\n        最大化企业利润的基础上"), _c('br'), _vm._v("\n        最优化管理库存和车队排"), _c('br'), _vm._v("\n        期调度\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-1"
  }, [_c('div', {
    staticClass: "content-1-title"
  }, [_vm._v("\n      专业 / 创新 / 前沿\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-1-text"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/co1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/co2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/co3.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-1-text content-1-text-2"
  }, [_c('div', [_vm._v("\n        专业的数据分析和"), _c('br'), _vm._v("数据优化建模团队\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        数据源的整合、网络规划"), _c('br'), _vm._v("实时监控\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        互联网开放团队，炫酷UI设计"), _c('br'), _vm._v("厚实高效的算法引擎\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-2"
  }, [_c('div', {
    staticClass: "content-2-title"
  }, [_vm._v("\n      Mii-RO亮点是什么？\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-2-text"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "55.2em"
    },
    attrs: {
      "src": require("assets/index/c2-1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "conten-2-right"
  }, [_c('div', {
    staticClass: "conten-2-right-c"
  }, [_c('div', {
    staticClass: "img-text"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/c2-3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("强大的优化算法引擎")])]), _vm._v(" "), _c('strong', [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "img-text"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/c2-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("前沿的用户界面体验")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c3-1.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c3-2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c3-3.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c3-4.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("assets/index/c3-5.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-4"
  }, [_c('div', {
    staticClass: "content-4-title"
  }, [_vm._v("\n      Mii-RO鲁棒功能组合\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text"
  }, [_c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("VRPTW")]), _vm._v("(VRP with time window)")])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note"
  }, [_vm._v("\n          即带有时间窗的车辆路径问题。每个客户都可以有对应的要求送达时间窗口，时间窗口可以多个。由于客户数比较多，我们会先把客户分组，然后对每个组求解路径规划模型。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/c4-1.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("MDVRP")]), _vm._v("(Mulit-Depot VRP)")])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note"
  }, [_vm._v("\n          即多个仓库的车辆路径问题。同样的货物可以在多个仓库获取，自动分配最优的选择给客户。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/c4-2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text"
  }, [_c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("Heterogeneous Fleet VRP")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note content-4-text-note-2"
  }, [_vm._v("\n          即多种车型的车辆路径问题。"), _c('br'), _c('br'), _vm._v("\n          例如："), _c('br'), _vm._v("\n          重型货车指汽车总质量在12吨以上，车长6米以上。"), _c('br'), _vm._v("\n          中型货车指汽车总质量大于4.5吨、小于12吨，车长小于6米。"), _c('br'), _vm._v("\n          轻型货车指汽车总质量小于等于4.5吨，车长小于6米。"), _c('br'), _vm._v("\n          微型货车指总质量小于1.8吨，车长小于等于3.56米的货车。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/c4-3.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-c"
  }, [_c('div', {
    staticClass: "content-4-text-title"
  }, [_c('div', [_c('span', {
    staticClass: "big-text"
  }, [_vm._v("IRP")]), _vm._v("(Inventory Routing Problem)")])]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-note content-4-text-note-2"
  }, [_vm._v("\n          即与库存结合的车辆路径问题。与客户库存管理结合的补货配送问题，自动生成配送订单，匹配配送车辆，用最优的配送方案，保证客户的库存 在指定范围内。"), _c('br'), _vm._v("\n          例如："), _c('br'), _vm._v("\n          车容量：13t"), _c('br'), _vm._v("\n          客户A：最大库存量8t        每天销量：8t"), _c('br'), _vm._v("\n          客户B：最大库存量10t       每天销量：5t\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-4-text-img"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/c4-4.png"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-content-5"
  }, [_c('div', {
    staticClass: "index-content-5-text"
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo-s.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-c-info"
  }, [_c('span', [_vm._v("邮箱：info@reemii.cn")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("电话: 0871-64589278")])]), _vm._v(" "), _c('div', {
    staticClass: "logo-c-info"
  }, [_c('span', [_vm._v("官网：http://www.reemii.cn")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("地址：昆明市西山区红星财富中心B座28楼")])]), _vm._v(" "), _c('div', {
    staticClass: "logo-c-qr"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/qr.png"),
      "alt": ""
    }
  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("扫一扫更精彩")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa6b7730","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/index.vue
// module id = 1014
// module chunks = 1